import React from 'react';
import svgPaths from "../../imports/Dash/svg-drwaidsec3.ts";
import './Sidebar.css'
import { Link, useLocation } from 'react-router-dom'; 

const Sidebar = () => {
    const location = useLocation(); 

    const navItems = [
        { label: "Dashboard", path: svgPaths.p2ef88400, viewBox: "0 0 16.9999 16.9999", width: 17, height: 17, pagePath: '/home'},
        { label: "Bookings", path: svgPaths.p275e7180, viewBox: "0 0 18.9999 14.9999", width: 19, height: 15 , pagePath: '/booking'},
        { label: "Users", path: svgPaths.p34752600, viewBox: "0 0 22.9999 10.4807", width: 23, height: 10.481 , pagePath: '/users'},
        { label: "Vehicles", path: svgPaths.p2d79ac00, viewBox: "0 0 16.9999 14.9999", width: 17, height: 15, pagePath: '/vehicles' },
        { label: "Gallery", path: svgPaths.p24591d20, viewBox: "0 0 18.4999 18.4999", width: 18.5, height: 18.5, pagePath: '/gallery' },
        { label: "Site Content", path: svgPaths.p24591d20, viewBox: "0 0 18.4999 18.4999", width: 18.5, height: 18.5, pagePath: '/content' },
    ];

    return ( 
        <aside className="sidebar">
            <div className="sidebar-brand">
                <div className="sidebar-brand-name">EVS Electrify Egypt</div>
                <div className="sidebar-brand-sub">Dashboard</div>
            </div>

            <nav className="sidebar-nav">
                {navItems.map((item) => {
                    
                    const isActive = location.pathname === item.pagePath;

                    return (
                        <Link to={item.pagePath} key={item.label} style={{ textDecoration: 'none' }}>
                            <div className={`sidebar-nav-link ${isActive ? "active" : ""}`}>
                                <svg
                                    fill="none"
                                    preserveAspectRatio="none"
                                    viewBox={item.viewBox}
                                    width={item.width}
                                    height={item.height}
                                    style={{ flexShrink: 0 }}
                                >
                                    <path
                                        d={item.path}
                                        fill={isActive ? "#56FF50" : "#A1A1AA"}
                                    />
                                </svg>
                                <span className="sidebar-nav-link-label">{item.label}</span>
                            </div>
                        </Link>
                    );
                })}
            </nav>

            <div className="sidebar-footer">
                <div>
                    <div className="sidebar-footer-name">Admin Console</div>
                    <div className="sidebar-footer-role">Global Access</div>
                </div>
            </div>
        </aside>
    );
}

export default Sidebar;